<template>
<span class="AllotDevice">
    <el-button class="AllotDeviceBtn" :type="btnType" @click="handleDialogShow">
        <slot name='btnText'>{{btnText ? btnText : $t(/*分配*/'device.distribute')}}</slot>
    </el-button>
    <el-dialog class="AllotDeviceDialog" :title="$t(/*分配*/'device.distribute')" width="500px" @close="handleDialogClose"
        :visible.sync="dialogShow" modal-append-to-body append-to-body :close-on-click-modal="false">
        <div class="dialog-container">
            <SelectUser :disabled-list='allotList.map(i => i.user_id)' @submit='handleAddAllot'/>

            <div class="form-item"  v-for="(item,index) of allotList" :key="index">
                <el-tooltip :content="item.username" placement="top">
                    <div class="key">{{item.username}}</div>
                </el-tooltip>
                <div class="value">
                    <el-date-picker v-model="item.expire_time" type="datetime" value-format='timestamp'
                        :placeholder="$t(/*请选择*/'c.select')+$t(/*过期时间*/'device.expire_time')" default-time="00:00:00" :picker-options="pickerOptions"/>
                </div>
                <div class="btn">
                    <el-button type="text danger" @click='handleRemoveAllot(index)'> <i class="icon i-error"/> </el-button>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleDialogClose">{{$t(/*取消*/'c.cancel')}}</el-button>
            <el-button @click="handleDialogConfirm" type="primary">{{$t(/*确定*/'c.confirm')}}</el-button>
        </div>
    </el-dialog>
</span>
</template>

<script>
import Core from '../../../core'
import dayjs from 'dayjs'

let now = dayjs().hour(0).minute(0).second(0)

export default {
    name: "AllotDevice",
    components: {
        SelectUser: () => import('@/components/popup-btn/SelectUser.vue')
    },
    props: {
        btnType: { type: String, default: 'text', },
        btnText: { type: String },

        space: { type: [String, Number], },
        detail: { type: Object, default: () => {return {}} }
    },
    data() {
        return {
            loading: false,
            dialogShow: false,

            allotList: [],

            pickerOptions: {
                // 快捷时间选择
                shortcuts: [{
                    text: '7' + this.$t(/*天*/'unit.day'),
                    onClick(picker) {
                        picker.$emit('pick', now.add(7, 'd').valueOf());
                    }
                },{
                    text: '30' + this.$t(/*天*/'unit.day'),
                    onClick(picker) {
                        picker.$emit('pick', now.add(30, 'd').valueOf());
                    }
                },{
                    text: '60' + this.$t(/*天*/'unit.day'),
                    onClick(picker) {
                        picker.$emit('pick', now.add(60, 'd').valueOf());
                    }
                }],
                disabledDate(time) {
                    return time.getTime() < dayjs().valueOf();
                }
            },
        }
    },
    methods: {
        async handleDialogShow() {
            this.loading = true
            await this.getAllotUserList();
            this.dialogShow = true
        },
        handleDialogClose() {
            this.dialogShow = false
            this.allotList = []
        },
        handleDialogConfirm() {
            let list = Core.Util.deepCopy(this.allotList)
            console.log('handleDialogConfirm list:', list)
            let l = []
            for (const item of list) {
                if (!item.expire_time) {
                    return this.$message.warning(this.$t(/*请选择*/'c.select')+this.$t(/*过期时间*/'device.expire_time'))
                }
                l.push({
                    user_id: item.user_id,
                    expire_time: Core.Util.countFilter(item.expire_time, 1000, 0),
                })
            }
            console.log('handleDialogConfirm l:', l)
            this.loading = true
            let apiName = 'distribute' + this.space
            Core.Api.Vehicle[apiName]({
                vehicle_id: this.detail.id,
                json: JSON.stringify(l)
            }).then(() => {
                this.$message.success(this.$t(/*操作成功*/'c.oper_success'));
                this.$emit('change')
                this.handleDialogClose();
            }).catch(err => {
                console.log('handleDialogConfirm err:', err)
                this.loading = false
            })
        },

        async getAllotUserList() {
            try {
                let {list} = await  Core.Api.Device.allotUserList({device_id: this.detail.device_id})
                console.log('getAllotUserList list:', list)
                for (const item of list) {
                    item.expire_time = item.expire_time * 1000 || ''
                }
                this.allotList = list
                console.log('getAllotUserList allotList:', this.allotList)
            } catch (error) {
                this.allotList = []
            }
        },

        handleAddAllot(ids, items) {
            items = items.map(item => ({
                user_id: item.id,
                username: item.username,
                expire_time: '',
            }))
            this.allotList.push(...items)
        },
        handleRemoveAllot(index) {
            this.allotList.splice(index, 1)
        },
    }

}
</script>

<style scoped lang="scss">
.AllotDeviceDialog {
    .form-item {
        &:first-of-type {
            margin-top: 15px;
        }
        .key {
            @include ell();
        }
        .value {
            width: calc(100% - 140px);
        }
        .btn {
            width: 40px;
            @include fcc();
        }
    }
}
</style>